export default {
  BASE_URL: '',
  api: [
    {
      name: 'save',
      desc: '新增/编辑客户',
      method: 'POST',
      path: '/crm/self/customer/save'
    },
    {
      name: 'audit',
      desc: '客户审核',
      method: 'POST',
      path: '/crm/self/customer/audit'
    },
    {
      name: 'del',
      desc: '删除客户',
      method: 'POST',
      path: '/crm/self/customer/del'
    },
    {
      name: 'detail',
      desc: '客户明细',
      method: 'GET',
      path: '/crm/self/customer/detail'
    },
    {
      name: 'list',
      desc: '客户列表',
      method: 'GET',
      path: '/crm/self/customer/list'
    },
    {
      name: 'changeSuInfo',
      desc: '修改客户业务员/批量',
      method: 'POST',
      path: '/crm/self/customer/changeSuInfo'
    },
    {
      name: 'getOrgType',
      desc: '获取企业类型',
      method: 'GET',
      path: '/crm/self/customer/getOrgType'
    },
    {
      name: 'getBillStatus',
      desc: '获取订单类型',
      method: 'GET',
      path: '/crm/self/customer/getBillStatus'
    },
    {
      name: 'findSelfCrmInfo',
      desc: '获取客户列表下拉框',
      method: 'GET',
      path: '/crm/self/customer/findSelfCrmInfo'
    },
    {
      name: 'getThirtyOrgInfo',
      desc: '根据企业统一信用代码获取企业名称',
      method: 'GET',
      path: '/crm/self/customer/getThirtyOrgInfo'
    },
    {
      name: 'getThirtyOrgInfoPartV5',
      desc: '企业检索接口',
      method: 'GET',
      path: '/crm/self/customer/getThirtyOrgInfoPart'
    },
    {
      name: 'modifyEnableStatusV5',
      desc: '启用禁用',
      method: 'GET',
      path: '/crm/self/customer/modifyEnableStatus'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/information/customer.js